import { useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import type { RootState } from "@/store/store";
import { checkAuthStatusRequest } from "@/store/slices/auth.slice";

export const useAuthStatus = () => {
  const dispatch = useDispatch();
  const { statusLoading, isAuthenticated, adminAuth, verifiedStores, error } =
    useSelector((state: RootState) => state.auth);

  return useMemo(
    () => ({
      statusLoading,
      isAuthenticated,
      adminAuth,
      verifiedStores,
      error,
      checkStatus: () => dispatch(checkAuthStatusRequest({ trigger: "manual-retry" })),
      refetch: () => dispatch(checkAuthStatusRequest({ trigger: "manual-retry" })),
    }),
    [statusLoading, isAuthenticated, adminAuth, verifiedStores, error, dispatch],
  );
};
